/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
/**
 * 
 * @export
 * @interface CustomerChannelUpdateDto
 */
export interface CustomerChannelUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof CustomerChannelUpdateDto
     */
    id?: number | null;
    /**
     * İsim
     * @type {string}
     * @memberof CustomerChannelUpdateDto
     */
    name?: string | null;
}

/**
 * Check if a given object implements the CustomerChannelUpdateDto interface.
 */
export function instanceOfCustomerChannelUpdateDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CustomerChannelUpdateDtoFromJSON(json: any): CustomerChannelUpdateDto {
    return CustomerChannelUpdateDtoFromJSONTyped(json, false);
}

export function CustomerChannelUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerChannelUpdateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function CustomerChannelUpdateDtoToJSON(value?: CustomerChannelUpdateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

